
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/facebook-leads-to-whatsapp",
      function () {
        return require("private-next-pages/whatsapp-integrations/facebook-leads-to-whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/facebook-leads-to-whatsapp"])
      });
    }
  